import { configureStore, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmbeddingSearchResultSchema } from "@labeling-tools/api/embeddington";

interface ProductAssociationState {
  searchTerms: string[];
  selectedItem: any;
  selectedPlanogramId: string | null;
  planogramSelectedProductId: string | null;
  stagedSelectedItem: EmbeddingSearchResultSchema | null;
  badDetection: boolean;
}

const initialProductAssociationState = {
  searchTerms: [],
  selectedItem: null,
  selectedPlanogramId: null,
  planogramSelectedProductId: null, // inital product selected in PlanogramModal
  stagedSelectedItem: null, // used in PlanogramModal. Converts to selectedItem when the "Confirm Item" button is clicked
  badDetection: false,
};

const productAssociationSlice = createSlice({
  name: "productAssociation",
  initialState: initialProductAssociationState,
  reducers: {
    addSearchTerm(
      state: ProductAssociationState,
      action: PayloadAction<string>,
    ) {
      state.searchTerms.push(action.payload);
    },
    setSelectedItem(
      state: ProductAssociationState,
      action: PayloadAction<any>,
    ) {
      state.selectedItem = action.payload;
    },
    setSelectedPlanogramId(
      state: ProductAssociationState,
      action: PayloadAction<string | null>,
    ) {
      state.selectedPlanogramId = action.payload;
    },
    setPlanogramSelectedProductId(
      state: ProductAssociationState,
      action: PayloadAction<string | null>,
    ) {
      state.planogramSelectedProductId = action.payload;
    },
    setStagedSelectedItem(
      state: ProductAssociationState,
      action: PayloadAction<EmbeddingSearchResultSchema | null>,
    ) {
      state.stagedSelectedItem = action.payload;
    },
    setBadDetection(
      state: ProductAssociationState,
      action: PayloadAction<boolean>,
    ) {
      state.badDetection = action.payload;
    },
    reset() {
      return initialProductAssociationState;
    },
  },
});

export const store = configureStore({
  reducer: {
    productAssociation: productAssociationSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const {
  addSearchTerm,
  setSelectedItem,
  setSelectedPlanogramId,
  setPlanogramSelectedProductId,
  setStagedSelectedItem,
  setBadDetection,
  reset,
} = productAssociationSlice.actions;
